<div class="notes-list">

    <ng-template #noteslistloading>
        <div class="loader">
            <div class="dimmed">
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
    </ng-template>

    <!-- Change view menu  -->

    <div class="view-mode-nav" *ngIf="files && files.length > 0">
        <ul>
            <li title="Display list view">
                <span (click)="changeView(FILES_VIEW_MODE_LIST)"
                 [ngClass]="{'view-mode-btn-active': viewMode == FILES_VIEW_MODE_LIST}" 
                 class="view-mode-btn list-view-ico"><em>Display list
                        view</em></span>
            </li>
            <li class="list-slash"><strong>/</strong></li>
            <li title="Display grid view">
                <span (click)="changeView(FILES_VIEW_MODE_GRID)"
                 [ngClass]="{'view-mode-btn-active': viewMode == FILES_VIEW_MODE_GRID}"
                 class="view-mode-btn grid-view-ico"><em>Display grid
                        view</em></span>
            </li>
        </ul>
    </div>

    <!-- GRID VIEW -->
    <div *ngIf="viewMode == FILES_VIEW_MODE_GRID else defaultviewmode "  class="displays-main">
        
        <ul class="grid-list" [ngClass]="{'last-row': files.length % 4 !== 0}" *ngIf="status == STATUS_DONE else noteslistloading">
            <li *ngFor="let file of files">
                <core-files-list-notes-grid-item
                    [file]="file"
                    [notes]="getNotes(file)"
                    [menu]="getItemFileMenu(file)"
                    [displayed]="fileSelected?.id == file.id || false"
                    (actionClick)="openPreview($event)"
                    (menuClick)="onMenuClick($event)"
                    (iconDownloadClick)="iconDownloadClick.emit($event)"
                ></core-files-list-notes-grid-item>
            </li>
        </ul>
        <!-- if we set pages, uncomment this and loop displayedFiles instead files -->
        <!-- <div class="display-more">
            <span [hidden]="displayedFiles.length == files.length || files.length < GRID_ITEMS_PER_PAGE" (click)="showMoreGridItems()">Show more . . . </span>
        </div> -->
    </div>
    <!-- LSIT DEFAULT VIEW -->
    <ng-template #defaultviewmode>
        <div   class="displays-main">
        <ul *ngIf="status == STATUS_DONE else noteslistloading" class="display-list">
            <li *ngFor="let file of files">
                <core-files-list-notes-item     
                    [file]="file"
                    [notes]="getNotes(file)"
                    [menu]="getItemFileMenu(file)"
                    [displayed]="fileSelected?.id == file.id || false"
                    (actionClick)="openPreview($event)"
                    (menuClick)="onMenuClick($event)"
                    (iconDownloadClick)="iconDownloadClick.emit($event)"
                ></core-files-list-notes-item>
            </li>
        </ul>
        </div>
    </ng-template>
</div>
